import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {Accordion as ReactAccordion} from 'react-accessible-accordion';
import Paragraph from "../Paragraph";
import {fieldObjectSectionStyle} from '../../helpers/graphQLShortcuts'
import {fieldObjectSectionStyleCss} from '../../helpers/createStyles';
import {filterHeadline, filterHTML} from "../../helpers/filters";

interface Data {
    paragraphById: {
        fieldObjectAccordionHeader: Array<{
            entity: Array<{
                fieldVarTextAlignment: string;
                fieldTxtHeadline: string;
                fieldHtmlBody: Array<{
                    value: string;
                    format: string;
                    processed: string;
                }>;
            }>;
        }>;
        fieldObjectSectionAccordion: Array;
        fieldInnerAccordionItem: Array<{targetRevisionId: string}>;
    }
}

class AccordionQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphComponentAccordion {
          fieldObjectAccordionHeader {
            entity {
              ... on Paragraph {
                ... on ParagraphInnerSectionHeader {
                  fieldVarTextAlignment
                  fieldTxtHeadline
                  fieldHtmlBody {
                    value
                    format
                    processed
                  }
                }
              }
            }
          }
          fieldObjectSectionAccordion {
              ${fieldObjectSectionStyle}
          }
          fieldInnerAccordionItem {
            targetRevisionId
          }
        }
      }
    }
  }
}
`;

const Accordion = ({id, markComponentLoadedAs, handleLoadedComponents}) => (
    <AccordionQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;
            const header = field.fieldObjectAccordionHeader ? field.fieldObjectAccordionHeader.entity : null;

            const styles = fieldObjectSectionStyleCss(field.fieldObjectSectionAccordion);

            if (!styles.css.padding) {
                styles.css.padding = '80px 20px';
            }

            markComponentLoadedAs(id, true);

            return (
                <div className={`accordion${styles.classNames}`} style={styles.css} id={styles.id}>
                    {styles.childBackground.isActive && (
                        <div style={styles.childBackground.css}/>
                    )}
                    <div className="container">
                        {header && header.fieldTxtHeadline && (
                            // eslint-disable-next-line react/no-danger
                            <h2 className="accordion__header" dangerouslySetInnerHTML={{__html: filterHeadline(header.fieldTxtHeadline)}} />
                        )}

                        {header.fieldHtmlBody && header.fieldHtmlBody.processed && (
                            // eslint-disable-next-line react/no-danger
                            <div className="accordion__body" dangerouslySetInnerHTML={{__html: filterHTML(header.fieldHtmlBody.processed)}}/>
                        )}

                        {field.fieldInnerAccordionItem && (
                            <ReactAccordion>
                                {field.fieldInnerAccordionItem.map(component => (
                                    <Paragraph key={`${id}_${component.targetRevisionId}`}
                                               id={String(component.targetRevisionId)}
                                               handleLoadedComponents={handleLoadedComponents}/>
                                ))}
                            </ReactAccordion>
                        )}
                    </div>
                </div>
            );
        }}
    </AccordionQuery>
);

Accordion.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    handleLoadedComponents: PropTypes.func.isRequired
};

export default Accordion;



// WEBPACK FOOTER //
// ./frontend/components/Accordion/Accordion.jsx